import { find as _find } from 'lodash';

class OmniSearchController {
  constructor($scope, $ngConfirm, authService, enums, $state) {
    "ngInject";

    this.$scope = $scope;
    this.$ngConfirm = $ngConfirm;
    this.enums = enums;
    this.$state = $state;
    this.authService = authService;

    this.searchTerm;

    this.panels = [];
    this.panels['enquiries'] = {loading: false, results: null};
    this.panels['contacts'] = {loading: false, results: null};

    this.currentEntityId = authService.authData.currentLocation.key;
    
    this.searching = false;
  }

  search() {    
    if (!this.searchTerm || this.searchTerm.length < 3) {
      this.$ngConfirm({
        title: "Error",
        content: `Please search with a minimum of 3 characters`,
        type: 'red',
        buttons: {
          ok: () => {}
        }
      });

      return;
    }

    this.panels.enquiries.loading = true;
    this.panels.contacts.loading = true;
    this.searching = true;

    this.$scope.$broadcast('omniSearch:search', this.searchTerm); 
  }

  panelLoaded(panelName, numResults) {
    this.panels[panelName].loading = false;
    this.panels[panelName].results = numResults;

    this.allPanelsLoaded();
  }

  allPanelsLoaded() {
    this.searching = _find(this.panels, o => o.loading) != null;
  }

  linkSelected(selectedObj) {
    if (selectedObj.entityId === this.currentEntityId){
      this.gotoLink(selectedObj);
      return;
    }

    this.$ngConfirm({
      title: "Warning",
      content: `The object you're trying to navigate is not in your currently selected location.<br><br>If you wish to proceed, your selected location will be updated`,
      type: 'orange',
      columnClass: 'l',
      buttons: {
        ok: {
          text: 'Proceed',
          btnClass: 'btn-primary',
          action: () => {
            this.authService.updateLocationById(selectedObj.entityId);
            this.gotoLink(selectedObj);
          }
        },
        cancel: {
          text: 'Not sure',
          btnClass: 'btn-default',
          action: () => {}
        }
      }
    });
  }

  gotoLink(selectedObj){
    switch(selectedObj.objectType) {
      case this.enums.OMNISEARCH_OBJECT_TYPE.Enquiry:      
        this.$state.go('enquiryEdit', {enquiryId: selectedObj.objectId});
        break;

      case this.enums.OMNISEARCH_OBJECT_TYPE.Contact:      
        this.$state.go('contactView', {contactId: selectedObj.objectId});
        break;        
    }
  }
}

export default OmniSearchController;



// WEBPACK FOOTER //
// ./client/app/components/omniSearch/omniSearch.controller.js